var _objectWithoutProperties = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _asyncToGenerator = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/main/index.ts
var main_exports = {};
__export(main_exports, {
  SeatsioDesigner: function SeatsioDesigner() {
    return _SeatsioDesigner;
  },
  SeatsioEventManager: function SeatsioEventManager() {
    return _SeatsioEventManager;
  },
  SeatsioSeatingChart: function SeatsioSeatingChart() {
    return _SeatsioSeatingChart;
  },
  isBooth: function isBooth() {
    return _isBooth;
  },
  isGeneralAdmission: function isGeneralAdmission() {
    return _isGeneralAdmission;
  },
  isSeat: function isSeat() {
    return _isSeat;
  },
  isSection: function isSection() {
    return _isSection;
  },
  isTable: function isTable() {
    return _isTable;
  }
});
module.exports = __toCommonJS(main_exports);

// src/main/Embeddable.tsx
var React = __toESM(require("react"));

// src/main/util.ts
var _didPropsChange = function didPropsChange(prevProps, nextProps) {
  if (Object.keys(prevProps).length !== Object.keys(nextProps).length) {
    return true;
  }
  return Object.keys(nextProps).some(function (propName) {
    var prevValue = prevProps[propName];
    var nextValue = nextProps[propName];
    if (prevValue && nextValue) {
      if (typeof prevValue === "function" && typeof nextValue === "function") {
        return prevValue.toString() !== nextValue.toString();
      }
      if (typeof prevValue === "object" && typeof nextValue === "object") {
        return _didPropsChange(prevValue, nextValue);
      }
    }
    return prevValue !== nextValue;
  });
};
var _isSeat = function _isSeat(obj) {
  return obj.objectType === "Seat";
};
var _isTable = function _isTable(obj) {
  return obj.objectType === "Table";
};
var _isSection = function _isSection(obj) {
  return obj.objectType === "section";
};
var _isBooth = function _isBooth(obj) {
  return obj.objectType === "Booth";
};
var _isGeneralAdmission = function _isGeneralAdmission(obj) {
  return obj.objectType === "GeneralAdmissionArea";
};

// src/main/Embeddable.tsx
var _Embeddable = /*#__PURE__*/function (_React$Component) {
  "use strict";

  _inherits(_Embeddable, _React$Component);
  function _Embeddable(props) {
    var _this;
    _classCallCheck(this, _Embeddable);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(_Embeddable).call(this, props));
    _this.container = React.createRef();
    _this.firstRender = true;
    return _this;
  }
  _createClass(_Embeddable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_Embeddable.seatsioBundles[this.getChartUrl()] || this.firstRender) {
        this.createAndRenderChart();
        this.firstRender = false;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (_didPropsChange(this.props, prevProps) && this.chart) {
        this.destroyChart();
        this.createAndRenderChart();
      }
    }
  }, {
    key: "getChartUrl",
    value: function getChartUrl() {
      return this.props.chartJsUrl.replace("{region}", this.props.region);
    }
  }, {
    key: "createAndRenderChart",
    value: function () {
      var _createAndRenderChart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var seatsio2, config;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.loadSeatsio();
            case 2:
              seatsio2 = _context.sent;
              config = this.extractConfigFromProps();
              config.container = this.container.current;
              this.chart = this.createChart(seatsio2, config).render();
              if (this.props.onRenderStarted) {
                this.props.onRenderStarted(this.chart);
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createAndRenderChart() {
        return _createAndRenderChart.apply(this, arguments);
      }
      return createAndRenderChart;
    }()
  }, {
    key: "extractConfigFromProps",
    value: function extractConfigFromProps() {
      var _this$props = this.props,
        chartJsUrl = _this$props.chartJsUrl,
        divId = _this$props.divId,
        onRenderStarted = _this$props.onRenderStarted,
        region = _this$props.region,
        config = _objectWithoutProperties(_this$props, ["chartJsUrl", "divId", "onRenderStarted", "region"]);
      return config;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyChart();
    }
  }, {
    key: "destroyChart",
    value: function destroyChart() {
      if (this.chart && this.chart.state !== "DESTROYED") {
        this.chart.destroy();
      }
    }
  }, {
    key: "loadSeatsio",
    value: function loadSeatsio() {
      var chartUrl = this.getChartUrl();
      if (!_Embeddable.seatsioBundles[chartUrl]) {
        _Embeddable.seatsioBundles[chartUrl] = new Promise(function (resolve, reject) {
          var script = document.head.appendChild(document.createElement("script"));
          window.seatsio = void 0;
          script.onload = function () {
            resolve(seatsio);
          };
          script.onerror = function () {
            return reject("Could not load ".concat(script.src));
          };
          script.src = chartUrl;
        });
      }
      return _Embeddable.seatsioBundles[chartUrl];
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */React.createElement("div", {
        ref: this.container,
        style: {
          "height": "100%",
          "width": "100%"
        }
      });
    }
  }]);
  return _Embeddable;
}(React.Component);
_Embeddable.seatsioBundles = {};
_Embeddable.defaultProps = {
  chartJsUrl: "https://cdn-{region}.seatsio.net/chart.js"
};
var Embeddable = _Embeddable;

// src/main/SeatsioDesigner.tsx
var _SeatsioDesigner = /*#__PURE__*/function (_Embeddable2) {
  "use strict";

  _inherits(_SeatsioDesigner, _Embeddable2);
  function _SeatsioDesigner() {
    _classCallCheck(this, _SeatsioDesigner);
    return _possibleConstructorReturn(this, _getPrototypeOf(_SeatsioDesigner).apply(this, arguments));
  }
  _createClass(_SeatsioDesigner, [{
    key: "createChart",
    value: function createChart(seatsio2, config) {
      return new seatsio2.SeatingChartDesigner(config);
    }
  }]);
  return _SeatsioDesigner;
}(Embeddable);

// src/main/SeatsioEventManager.tsx
var _SeatsioEventManager = /*#__PURE__*/function (_Embeddable3) {
  "use strict";

  _inherits(_SeatsioEventManager, _Embeddable3);
  function _SeatsioEventManager() {
    _classCallCheck(this, _SeatsioEventManager);
    return _possibleConstructorReturn(this, _getPrototypeOf(_SeatsioEventManager).apply(this, arguments));
  }
  _createClass(_SeatsioEventManager, [{
    key: "createChart",
    value: function createChart(seatsio2, config) {
      return new seatsio2.EventManager(config);
    }
  }]);
  return _SeatsioEventManager;
}(Embeddable);

// src/main/SeatsioSeatingChart.tsx
var _SeatsioSeatingChart = /*#__PURE__*/function (_Embeddable4) {
  "use strict";

  _inherits(_SeatsioSeatingChart, _Embeddable4);
  function _SeatsioSeatingChart() {
    _classCallCheck(this, _SeatsioSeatingChart);
    return _possibleConstructorReturn(this, _getPrototypeOf(_SeatsioSeatingChart).apply(this, arguments));
  }
  _createClass(_SeatsioSeatingChart, [{
    key: "createChart",
    value: function createChart(seatsio2, config) {
      return new seatsio2.SeatingChart(config);
    }
  }]);
  return _SeatsioSeatingChart;
}(Embeddable);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SeatsioDesigner: _SeatsioDesigner,
  SeatsioEventManager: _SeatsioEventManager,
  SeatsioSeatingChart: _SeatsioSeatingChart,
  isBooth: _isBooth,
  isGeneralAdmission: _isGeneralAdmission,
  isSeat: _isSeat,
  isSection: _isSection,
  isTable: _isTable
});